import { ToastContainer as RTContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./style.module.css";
export function ToastContainer() {
  return (
    <RTContainer
      pauseOnFocusLoss
      position="top-right"
      hideProgressBar
      pauseOnHover
      className={styles.toastLocation}
    />
  );
}
